module.exports = __webpack_public_path__ + "static/media/tracis_horiz_white_large.288a13be.png";